import React from "react";
import PageLayout from "./templates/PageLayout";
import TitleSection from "../components/sections/TitleSection";
import { Text, Button, Flex, Box } from "@thenounproject/lingo-core";
import { Container } from "../components/Elements";

const sitemapData: Record<string, { label: string; href: string }[]> = {
  Product: [
    { label: "Home", href: "/" },
    { label: "Asset Library", href: "/product/library" },
    { label: "Asset Management Analytics", href: "/product/insights" },
    { label: "Asset Management Kits", href: "/product/kits" },
    { label: "Custom Branding", href: "/product/custom-branding" },
    { label: "Digital Asset Management Features", href: "/product/features" },
    // { label: "Portals", href: "#" },
  ],
  "By Role": [
    { label: "Brand Teams", href: "/solutions/brand-teams" },
    { label: "Agencies", href: "/solutions/agencies" },
  ],
  Resources: [
    { label: "Example Brand Portal", href: "https://acme.lingoapp.com" },
    { label: "Pricing", href: "/pricing" },
    { label: "Lingo's Help Center", href: "https://help.lingoapp.com/en/" },
    { label: "Blog", href: "/blog" },
    { label: "Product Stories", href: "/blog/collection/product" },
    // { label: "Customer Stories", href: "#" },
  ],
  Solutions: [
    { label: "Brand Guidelines", href: "/solutions/brand-guidelines" },
    { label: "Digital Asset Management", href: "/solutions/digital-asset-management" },
    { label: "Digital Brand Hub", href: "/solutions/digital-brand-hub" },
    { label: "Enterprise Digital Asset Management", href: "/enterprise" },
  ],
  Integrations: [
    { label: "Lingo's API", href: "/integrations/api" },
    { label: "Developers", href: "https://developer.lingoapp.com/" },
    { label: "Integrations & Apps", href: "/product/integrations" },
    { label: "Integrate with Dropbox", href: "/integrations/dropbox" },
    { label: "Integrate with Figma", href: "/integrations/figma" },
    { label: "Integrate with Google Drive", href: "/integrations/google" },
  ],
  Company: [
    { label: "About", href: "/about" },
    { label: "Accessibility", href: "/accessibility" },
    { label: "API Terms of Use", href: "/legal#api-terms-of-use" },
    { label: "Privacy Policy", href: "/legal#privacy-policy" },
    { label: "Terms of Use", href: "/legal#terms-of-use" },
    { label: "Login", href: "/login" },
    { label: "Request a demo", href: "/book-demo" },
    { label: "Start a trial", href: "/request-trial" },
    { label: "Contact Us", href: "/contact" },
  ],
};

const Section = ({
  title,
  routes,
}: {
  title: string;
  routes: { label: string; href: string }[];
}) => (
  <Flex flexDirection="column" gap="16px" p="l">
    <Text font="marketing.h4">{title}</Text>
    <Flex flexDirection="column" gap="8px">
      {routes.map(route => (
        <Button key={route.label} link={route.href} buttonStyle="tertiary" text={route.label} />
      ))}
    </Flex>
  </Flex>
);

export default function Sitemap() {
  const sectionEntries = Object.entries(sitemapData);
  const [left, right] = [sectionEntries.slice(0, 3), sectionEntries.slice(3)];
  // 3 is half of the total number of sections (6). May need to be changed in the future if additional sections are added or if sections are removed, since we're overhauling the marketing site anyway.

  return (
    <PageLayout style="dark">
      <TitleSection mt="-72px" pt="150px" pb="80px" style="dark" title="Sitemap" />
      <Container maxWidth="960px" mx="auto">
        <Flex flexDirection="row" variations={{ "mq.s": { flexDirection: "column" } }}>
          {[left, right].map((group, i) => (
            <Box key={i} flex="1">
              {group.map(([title, routes]) => (
                <Section key={title} title={title} routes={routes} />
              ))}
            </Box>
          ))}
        </Flex>
      </Container>
    </PageLayout>
  );
}
